import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_overtime_hours_paid_at_a_premium_rate_of_at_least_125_times'

export const dataPointDefinition = {
  retracedId: 'are_overtime_hours_paid_at_a_premium_rate_of_at_least_125_times',
  name: 'Are overtime hours paid at a premium rate of AT LEAST 1.25 times the base rate?',
  description:
    "The intent of this question is to understand if the facility's premium rate for overtime hours is at least 1.25 for all workers. A premium rate of 1.25 is equal to the basic wage rate multiplied by 25%. \r\r\n\r\r\nAccording to ILO Conventions No. 1 and No. 30, the rate of pay for overtime shall not be less than one-and-one-quarter times the regular rate. Meaning at least 1.25 times the basic rate.",
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-4--5',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 7500,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
